module.exports = __webpack_public_path__ + "img/portugal-respiratory-diseases-male.f48451fb.png";